export const getPrice_evl = ({ area, qualityindex, physicalWidth, unit, folder }) => {
  var rugPadRate;
  var rugPadArea = area;

  // Conversion constants
  const SQFT_TO_M2 = 0.092903; // 1 ft² = 0.09290304 m²
  const M2_TO_SQFT = 10.7639; // 1 m² = 10.7639 ft²
  const fttocm = 30.48;
  let rates;
  let totalPrice;
  var totalRugPadPrice;
  let widthThreshold;

  if (unit === "cm") {
    rugPadArea = (area * M2_TO_SQFT).toFixed(2);
    widthThreshold = 12 * fttocm;
  } else {
    widthThreshold = 12;
  }
  rugPadRate = rugPadArea > 50 ? 3.25 : 4;

  if (physicalWidth > widthThreshold) {
    const specialRateFt2 =
      folder != "Jute"
        ? [48.75, 57.75, 63.25, 73.25, 36, 34]
        : [48.75, 57.75, 63.25, 73.25, 36, 34, 31];

    // Convert rate to per m² if needed
    rates = specialRateFt2[qualityindex];
  } else {
    const rate_sqft = [
      {
        area: 50,
        rate:
          folder != "Jute"
            ? [46.25, 55.25, 60.25, 70.25, 34, 32]
            : [46.25, 55.25, 60.25, 70.25, 34, 32, 29]
      },
      {
        area: 180,
        rate:
          folder != "Jute"
            ? [48.75, 57.75, 63.25, 73.25, 36, 34]
            : [48.75, 57.75, 63.25, 73.25, 36, 34, 31]
      }
    ];

    const matches = rate_sqft.filter(elem => rugPadArea > elem.area);
    const rate_values = matches[matches.length - 1] || rate_sqft[0];
    rates = rate_values.rate[qualityindex];
  }

  // Calculate price
  totalPrice = rugPadArea * rates;
  var totalRugPadPrice = parseFloat(totalPrice) + rugPadRate * rugPadArea;

  return {
    totalPrice,
    rugPadRate,
    totalRugPadPrice
  };
};
